export enum StatusAvailability {
  Include = 'include',
  Exclude = 'exclude',
  Only = 'only',
}
